export enum Routes {
  Home = "home",
  Login = "login",
  SessionExpired = "session-expired",
  DashBoard = "dashboard",
  CallHistory = "call-history",
  OnHold = "on-hold",
  Agents = "agents",
  Verification = "verification",
  DIDs = "dids",
  Kibana = "kibana-dashboard",
  ViewLead = "view-lead",
  LookupLead = "lookup-lead",
  Commissions = "commissions",
  TwiloEvents = "twilio-events",
  Leads = "leads",
  LeadSources = "lead-sources",
  Dispositions = "dispositions",
  DoctorNominations = "doctor-nominations",
  Settings = "settings",
  Products = "products",
  MessageTemplates = "message-templates",
  PostDates = "post-dates",
  Blacklist = "blacklist"
}
